import config from '../config'
import { authorizedFetch }  from '../utils/auth'
import { checkStatus } from '../utils/fetch'
import { logout } from './auth'

export const FETCH_EVENTS = 'FETCH_EVENTS'
export const UPDATE_EVENT = 'UPDATE_EVENT'
export const SHOW_EVENT_DETAILS = 'SHOW_EVENT_DETAILS'
export const HIDE_EVENTS_DETAILS = 'HIDE_EVENTS_DETAILS'
export const RECEIVED_EVENTS = 'RECEIVED_EVENTS'

export const fetchEvents = (userId) => dispatch => {
		var headers = new Headers()

		headers.append('Content-Type', 'application/json');
		headers.append('Access-Control-Allow-Origin', '*');
		headers.append('Accept', 'application/json');

		authorizedFetch(config.api_url + 'events/list/' + userId,
			{
				headers: headers,
				cache: 'default',
				method: "GET",
			})
			.then(checkStatus)
			.then(response => response.json())
      .then(json => dispatch(receivedEvents(json)))
			.catch(function(error) {
				dispatch(logout())
			});
}

export const updateEvent = (event) => ({
		type: UPDATE_EVENT,
		event: event
})

export const registerSession = (session, account) => dispatch => {
	var headers = new Headers()

	headers.append('Content-Type', 'application/json');
	headers.append('Access-Control-Allow-Origin', '*');
	headers.append('Accept', 'application/json');

	authorizedFetch(config.api_url + 'events/register/' + session._id + '/' + account._id,
		{
			headers: headers,
			mode: 'cors',
			cache: 'default',
			method: "POST",
			body: JSON.stringify({platform: "web", author: account.fullName})
		})
		.then(checkStatus)
		.then(response => response.json())
		.then(response => dispatch(updateEvent(response.event)))
		.catch(function(error) {
			dispatch(logout())
		});
}

export const unregisterSession = (session, account) => dispatch => {
	var headers = new Headers()

	headers.append('Content-Type', 'application/json');
	headers.append('Access-Control-Allow-Origin', '*');
	headers.append('Accept', 'application/json');

	authorizedFetch(config.api_url + 'events/unregister/' + session._id + '/' + account._id,
		{
			headers: headers,
			mode: 'cors',
			cache: 'default',
			method: "POST",
			body: JSON.stringify({platform: "web", author: account.fullName})
		})
		.then(checkStatus)
		.then(response => response.json())
		.then(response => dispatch(updateEvent(response)))
		.catch(function(error) {
			dispatch(logout())
		});
}

export const hideEventDetails = () => ({
	type: HIDE_EVENTS_DETAILS,
})

export const showEventDetails = (event) => ({
  type: SHOW_EVENT_DETAILS,
	event: event
})

export const receivedEvents = (events) => ({
  type: RECEIVED_EVENTS,
  events: events
})



// WEBPACK FOOTER //
// ./src/actions/events.js